module.exports = __webpack_public_path__ + "img/9e3ea2d.jpg";